module.exports = __webpack_public_path__ + "img/viral-video.668ce82a.webp";